import styled from 'styled-components';
import { Link } from '@resideo/blueprint-react';

export const DisabledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.faded}!important;
`;
